import React from 'react';
import TextField from "./TextField";

class Material extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let style = {margin: 20};
        return (
            <div style={style}>
                <TextField
                    inputId="textfield_1"
                    labelText="Label"
                    helperText="Resting label"
                    width={400} />
                <TextField
                    inputId="textfield_1"
                    placeholderText="Placeholder"
                    helperText="No label, with placeholder"
                    width={400} />
                <TextField
                    inputId="textfield_1"
                    placeholderText="No label and no helper text"
                    width={400} />
                <TextField
                    inputId="textfield_2"
                    labelText="Label"
                    value="Value"
                    helperText="Resting label and value"
                    width={400} />
                <TextField
                    inputId="textfield_3"
                    labelText="Label"
                    placeholderText="Placeholder"
                    helperText="Resting label and placeholder"
                    width={400} />
                <TextField
                    inputId="textfield_4"
                    labelText="Label"
                    placeholderText="Placeholder"
                    value="Value"
                    helperText="Resting label, placeholder and value"
                    width={400} />
                <TextField
                    inputId="textfield_5"
                    labelText="Label"
                    floatingLabel={true}
                    placeholderText="Placeholder"
                    helperText="Floating label and placeholder"
                    width={400} />
                <TextField
                    inputId="textfield_6"
                    labelText="Label"
                    placeholderText="Placeholder"
                    value="Value"
                    helperText="Helper text"
                    error={true}
                    errorText="Error with error text"
                    width={400} />
                <TextField
                    inputId="textfield_7"
                    fullWidth={true}
                    placeholderText="Full width"
                    width={400} />
                <TextField
                    inputId="textfield_8"
                    disabled={true}
                    labelText="Label"
                    placeholderText="Placeholder"
                    helperText="Disabled with resting label"
                    width={400} />
                <TextField
                    inputId="textfield_9"
                    disabled={true}
                    labelText="Label"
                    value="Value"
                    placeholderText="Placeholder"
                    helperText="Disabled with value"
                    width={400} />
                <TextField
                    inputId="textfield_10"
                    disabled={true}
                    labelText="Label"
                    placeholderText="Placeholder"
                    floatingLabel={true}
                    helperText="Disabled with placeholder and floating label"
                    width={400} />
                <TextField
                    inputId="textfield_11"
                    labelText="Label"
                    placeholderText="Placeholder"
                    helperText="Multiline"
                    multiLine={true}
                    width={400} />
            </div>
        );
    }

}

Material.propTypes = {};
Material.defaultProps = {};

export default Material;



// WEBPACK FOOTER //
// ./src/components/material/Material.js